export default __webpack_public_path__ + "static/media/img-0055-usa-full-face.794fdde9.png";